// extracted by mini-css-extract-plugin
export default {"wrapper":"W0-z","play":"X0-z"};